import { apiFetch } from '../../api/api';

export const PRINT_REQUEST_TIMEOUT_MS = 30000;

// A deadline bounds observation, not execution. Aborting this HTTP request
// cannot cancel a job that the server may already have accepted.
export function startGalleryPrintRequest(body) {
  const controller = new AbortController();
  let settle;
  let finished = false;
  let timer;
  const promise = new Promise(resolve => { settle = resolve; });
  const finish = result => {
    if (finished) return;
    finished = true;
    clearTimeout(timer);
    settle(result);
  };
  const cancel = () => {
    finish({ admitted: null });
    controller.abort();
  };
  timer = setTimeout(cancel, PRINT_REQUEST_TIMEOUT_MS);
  // Exactly one attempt; even authentication failures must not replay a POST.
  try {
    Promise.resolve(apiFetch('/gallery/photos/print', {
      method: 'POST', body, retryAuth: false, signal: controller.signal
    })).then(finish, error => finish(error?.response?.data || { admitted: null }));
  } catch (error) {
    finish(error?.response?.data || { admitted: null });
  }
  return { promise, cancel };
}
